<template>
  <div class="filter-item">
    <span v-for="(filterItem, index) in filterList" :key="'filter_' + index">
      <FilterItem :filter-item="filterItem" :selected-items="selectedItems"/>
    </span>
  </div>
</template>
<script>
import _ from 'lodash'
import { parse } from 'query-string'
import FilterItem from '@/pages/list/FilterItem'
export default {
  name: 'ListFilter',
  components: {
    FilterItem
  },
  props: {
    filter: {
      type: Object
    }
  },
  data () {
    return {
      filterList: [],
      selectedItems: {}
    }
  },
  mounted () {
    this.filterList = _.get(this.filter, 'filterlist', [])
  },
  created () {
    const query = this.$route.query
    const defaultParameters = parse(_.get(this.filter, 'default_api_parameters'))
    this.selectedItems = _.assign({}, defaultParameters, query)
  }
}
</script>
